import { createSlice } from '@reduxjs/toolkit'

export const textSlice = createSlice({
    name: 'texts',
    initialState: {
        texts: []
    },
    reducers: {
        setTexts(state, action) {
            state.texts = action.payload;
        },
        addText(state, action) {
            const newText = action.payload
            const existingIdx = state.texts.findIndex(t => t.id === newText?.id)

            // check if text template is already in texts array
            // and only update fields on the template that
            // have changed.
            if(existingIdx > -1){
                state.texts[existingIdx] = {
                    ...state.texts[existingIdx],
                    ...newText
                }
            } else {
                state.texts.unshift(action.payload)
            }
        },
        removeText(state, action) {
            const { id } = action.payload
            state.texts = state.texts.filter(t => t.id !== id)
        },
    },
})
export const { setTexts, addText, removeText } = textSlice.actions;

export default textSlice.reducer

